<template>
  <v-navigation-drawer
    :value="value"
    @input="input => $emit('input', input)"
    fixed
    temporary
    right
    width="1200"
  >
    <div style="min-height: 100%; overflow-y: hidden; background-color: #f1f3f4;" class="d-flex flex-column">
      <header class="pa-4 white d-flex align-center" style="font-size: 1.3em; height: 64px;">
        <v-btn icon @click="$emit('input', false)" class="mr-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="title grey--text text--darken-2">Escolher plano</div>
      </header>
      <v-divider></v-divider>
      <div v-if="loading" class="flex-grow-1 d-flex justify-center align-center flex-column">
        <v-progress-circular
          :width="3"
          :size="60"
          color="blue"
          indeterminate
        ></v-progress-circular>
        <small class="mt-6">Por favor, aguarde enquanto estamos processando seu pedido...</small>
      </div>
      <div v-else-if="paymentUrl" class="flex-grow-1 d-flex justify-center align-center flex-column text-center black--text">
        <h2 class="mb-10 text-h4 font-weight-bold" style="color: #1CC5A1;">Sua fatura foi gerada!</h2>
        <div class="d-flex flex-column" style="line-height: 1.8; max-width: 610px;">
          <span>Neste momento deve abrir uma nova aba com informações para realizar o pagamento do seu plano. Caso isso não ocorra, por favor, <a :href="paymentUrl" style="color: black; text-decoration: none;" class="font-weight-bold" target="_blank">clique aqui</a>.</span>
          <span>Você também receberá uma cópia por email.</span>
        </div>
      </div>
      <zp-payer
        v-else-if="plan"
        @confirm="makeUrl"
        :plan="plan"
        :coupon="dataCoupon"
        @coupon="_coupon => coupon = _coupon"
        :users="users[plan.id]"
        @cancel="plan = null"
      ></zp-payer>
      <template v-else>
        <div class="d-flex justify-center pb-3 mt-15 mb-10">
          <div style="width: 270px;" class="d-flex flex-column align-center" v-for="(plan, index) in plans" :key="index">
            <div>
              <div class="d-flex flex-column" style="line-height: 1">
                <span class="text-h4 font-weight-bold">{{plan.name}}</span>
                <span style="position: relative; top: -5px" class="text-h6 font-weight-bold">anual</span>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bold text-h4" style="color: #00C57E;">12x {{getDiscount(plan.monthly_price / 100) | currency}}</span>
                <span class="font-weight-bold">ou {{(getDiscount(plan.annual_price / 100)) | currency}} à vista</span>
              </div>
              <div class="d-flex flex-column mt-5" style="line-height: 1.8">
                <v-select
                  outlined
                  label="Seu time"
                  style="width: 220px;"
                  class="mb-3"
                  v-model="users[plan.id]"
                  :items="[
                    { text: `1 usuário (incluso)`, value: 1 },
                    { text: `2 usuários (${plan.max_users > 1 ? 'incluso' : 'por ' + $options.filters.currency(getDiscount(97))})`, value: 2 },
                    { text: `3 usuários (${plan.max_users > 2 ? 'incluso' : 'por ' + $options.filters.currency(getDiscount((3 - plan.max_users) * 97))})`, value: 3 },
                    { text: `4 usuários (${plan.max_users > 3 ? 'incluso' : 'por ' + $options.filters.currency(getDiscount((4 - plan.max_users) * 97))})`, value: 4 },
                    { text: `5 usuários (${plan.max_users > 4 ? 'incluso' : 'por ' + $options.filters.currency(getDiscount((5 - plan.max_users) * 97))})`, value: 5 }
                  ]"
                  hide-details
                  dense
                ></v-select>
                <span>Cliques ilimitados</span>
                <span>{{plan.max_domains}} domínios</span>
                <span v-if="plan.max_links >= 1000000">Links ilimitados</span>
                <span v-else>{{plan.max_links}} links</span>
                <span>{{plan.max_pages}} page{{plan.max_pages > 1 ? 's' : ''}} (em breve)</span>
                <span>Servidor Google</span>
                <span class="pointer font-italic" :loading="loading" @click="openInNewTab('https://zaper.in/#planos')">+ Todas funções</span>
              </div>
            </div>
            <v-btn class="mt-5" color="#00C57E" style="width: 220px" depressed dark @click="setPlan(plan)">Quero este</v-btn>
          </div>
        </div>
        <div class="d-flex justify-center align-center pb-8">
          <div class="d-flex flex-column mr-6" style="max-width: 370px; width: 100%;">
            <span class="font-weight-bold">Adicione seu time no Gerenciador</span>
            <span style="line-height: 1.1">Gerencie projetos, crie/edite links, acompanhe o desempenho e duplique links. Caso queira inserir um novo usuário em seu plano já ativo, fale com nosso <strong>suporte</strong>.</span>
          </div>
          <div class="d-flex flex-column" style="line-height: 1">
            <span class="font-weight-bold text-h5 blue--text">R$ 97,00</span>
            <span class="font-weight-bold grey--text text--darken-1">por usuário</span>
          </div>
        </div>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import PlanService from '@/services/PlanService'
import InvoiceService from '@/services/InvoiceService'
import ZpPayer from '@/components/Payer'

export default {
  props: ['value'],
  components: {
    ZpPayer
  },
  data () {
    return {
      loading: false,
      plans: [],
      plan: null,
      users: {},
      paymentUrl: null,
      coupon: null,
      dataCoupon: null
    }
  },
  mounted () {
    this.index()
  },
  methods: {
    async index () {
      this.plans = await PlanService.index()
      this.plans.sort((a, b) => a.annual_price - b.annual_price)
      this.users = {}

      for (const plan of this.plans) {
        this.users = {
          ...this.users,
          [plan.id]: plan.max_users
        }
      }
    },
    setPlan (plan) {
      this.plan = plan
    },
    getDiscount (amount) {
      return this.dataCoupon && this.activeCoupon ? amount - (amount * (this.dataCoupon.value / 100)) : amount
    },
    async makeUrl (installments) {
      this.step = ''
      this.loading = true
      const data = await InvoiceService.store({
        plan_id: this.plan.id,
        installments,
        users: this.users[this.plan.id],
        coupon_code: this.coupon
      })
      this.loading = false
      this.paymentUrl = data.payment_url

      try {
        window.dataLayer.push({ event: 'REDIRECIONADO_PARA_PAGAMENTO' })
      } catch (e) {
        console.error(e)
      }

      window.open(data.payment_url, '_blank')
    },
    openInNewTab (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>